import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/lib/locale/pt';

Vue.use(Vuetify)

// Textos padrão em PT-BR para todos os componentes
var ptCustom = Object.assign({}, pt, {
    dataTable: {
        itemsPerPageText: 'Itens por página:',
        ariaLabel: {
            sortDescending: 'Ordenado decrescente.',
            sortAscending: 'Ordenado crescente.',
            sortNone: 'Não ordenado.',
            activateNone: 'Ative para remover ordenação.',
            activateDescending: 'Ative para ordenar decrescente.',
            activateAscending: 'Ative para ordenar crescente.',
        },
        sortBy: 'Ordenar por',
    },
    dataFooter: {
        itemsPerPageText: 'Itens por página:',
        itemsPerPageAll: 'Todos',
        nextPage: 'Próxima página',
        prevPage: 'Página anterior',
        firstPage: 'Primeira página',
        lastPage: 'Última página',
        pageText: '{0}-{1} de {2}',
    },
    noDataText: 'Nenhum registro encontrado.',
    dataIterator: {
        noResultsText: 'Nenhum resultado encontrado para a busca.',
        loadingText: 'Carregando dados...',
    },
});

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#832472',
                secondary: '#16968D',
                accent: '#5972FF',
                error: '#F26D6E',
                warning: '#FFC837',
                success: '#1E6A1C',
                info: '#32BCB8',
                anchor: '#832472',
            },
        },
    },

    lang: {
        locales: { pt: ptCustom },
        current: 'pt',
    },
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js